module.exports = __webpack_public_path__ + "img/inbox.c3b719e4.svg";